import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

// Native port of the legacy deleteCompanyContactModal
// (src/app/public/app/partials/missioncontrol/company/deleteCompanyContactModal) -
// opened from company-page.component.js's deleteContactUserInfoModal
// (component: 'deleteCompanyContactModal'). Ported alongside step 7 (Client
// BUs) since it's invoked from the contacts list shown for
// associated-client updates, same grouping as the spec's build step 8.
//
// Like-for-like port of DeleteCompanyContactModalController's logic
// (userDetails.name concatenation, _setDeleteContactInfo's contact.name
// fallback, removeContact/existingUserChanged/close/dismiss behavior).
@Component({
  selector: 'app-company-page-delete-company-contact-modal',
  templateUrl: './company-page-delete-company-contact-modal.component.html'
})
export class CompanyPageDeleteCompanyContactModalComponent implements OnInit {

  public onClose: Subject<any>;

  modalData: any = {};

  userDetails: any;
  deleteContactUserInfo: any;
  selectedExistingContact: any = null;
  isSaveClicked = false;

  callbackObject: any = { callbackType: 'cancel', entity: { primaryContact: null } };

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
    this.userDetails = this.modalData.userDetails;
    this.userDetails.name = this.userDetails.firstName + this.userDetails.lastName;
    this.deleteContactUserInfo = this.modalData.deleteContactUserInfo;
    this._setDeleteContactInfo();
  }

  private _setDeleteContactInfo() {
    if (this.deleteContactUserInfo.contactsList) {
      this.deleteContactUserInfo.contactsList.map((contact: any) => {
        if (!contact.name || contact.name === '') {
          contact.name = contact.firstName + ' ' + contact.lastName;
        }
      });
    }
  }

  removeContact() {
    this.isSaveClicked = true;
    if (this.deleteContactUserInfo.contactsList.length === 0) {
      this.closeModal();
    } else {
      if (this.selectedExistingContact) {
        this.closeModal();
      }
    }
  }

  existingUserChanged() {
    this.isSaveClicked = false;
    this.callbackObject.entity.primaryContact = this.selectedExistingContact ? this.selectedExistingContact : null;
  }

  closeModal() {
    this.onClose.next(this.callbackObject);
    this.bsModalRef.hide();
  }

  dismissModal() {
    this.callbackObject = { callbackType: 'cancel', entity: { primaryContact: null } };
    this.onClose.next(this.callbackObject);
    this.bsModalRef.hide();
  }
}
